module.exports = __webpack_public_path__ + "static/media/3DPPA39.25580b99.jpg";